<p-dropdown
  appendTo="body"
  [options]="options!"
  [(ngModel)]="selectedItem"
  (onChange)="itemChanged($event)"
  [filter]="true"
  optionValue="id"
  optionLabel="naziv"
>
</p-dropdown>
